import { ChangeDetectionStrategy, Component, inject, output, input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { IonSpinner } from '@ionic/angular/standalone';
import { CurrencyAmountDisplay } from 'src/app/shared/utils/currency/currency-format';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { ThemePipe } from 'src/app/core/pipes/theme.pipe';
import { CurrencyIconComponent } from '../../currency/currency-icon/currency-icon.component';

@Component({
  selector: 'app-balance-pill',
  templateUrl: './balance-pill.component.html',
  styleUrls: ['./balance-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, IonSpinner, CurrencyIconComponent, ThemePipe],
})
export class BalancePillComponent {
  readonly balance = input<CurrencyAmountDisplay>();

  readonly balanceClickedEvent = output<void>();

  themeService = inject(ThemeService);

  readonly balancePillStyles: [string, string][] = [
    ['background', 'pill-balance'],
    ['border-radius', 'pill-balance'],
    ['text-color', 'pill-balance-amount'],
    ['type', 'pill-balance-amount'],
    ['border', 'pill-balance'],
  ];

  onBalanceClicked(): void {
    this.balanceClickedEvent.emit();
  }
}
